const BASE = 'dialog :';

export const dialogActionTypes = {
  openDialog: `${BASE} open`,
  closeDialog: `${BASE} close`,
};

/**
 * Open a dialog
 * @param {object} props
 * @param {string} [props.title]
 * @param {string | JSX.Element} [props.message]
 * @param {string | JSX.Element} [props.body]
 * @param {Array<JSX.Element | string | object>} [props.buttons]
 * @param {function} [props.onClose]
 */
export const openDialog = ({ title, message, body, buttons, onClose }) => ({
  type: dialogActionTypes.openDialog,
  message,
  body,
  title,
  buttons,
  onClose,
});

export const closeDialog = () => ({
  type: dialogActionTypes.closeDialog,
});
